export default {
    methods: {
        getMsgBox(title, message) {
            return this.$bvModal
                    .msgBoxOk(message,
                                    {
                                        'modal-class': "dark",                                        
                                        title: 'Mensagem',
                                        headerBgVariant: 'success',
                                        okVariant: 'primary',
                                        okTitle: "Fechar",
                                        footerClass: 'p-2',
                                        'cancel-disabled': true,
                                        modalClass: this.$store.getters.getTheme,
                                        hideHeaderClose: true,
                                        centered: true
                                    }
                    )
        },
        getMsgBoxFechar(message) {
            const h = this.$createElement
            const titleVNode = h('div', { domProps: { innerHTML: '<i></i>  ' } })

            return this.getMsgBox([titleVNode], message)
        },
        getMsgBoxRedirecionamento(redirecionamento) {
            const h = this.$createElement
            const message = h('div', { domProps: { innerHTML: redirecionamento.redirecionamento.mensagem } })

            if(redirecionamento?.redirecionamento?.linkRedirecionamento?.length > 0) {
                return this.$bvModal.msgBoxConfirm([message],
                                    {
                                        id: 'msgbox-redirecionamento',
                                        'modal-class': "dark",
                                        'title': redirecionamento.redirecionamento.tituloTela,
                                        headerBgVariant: 'primary',
                                        okVariant: 'primary',
                                        okTitle: "Ir para o Site",
                                        cancelTitle: 'Voltar',
                                        footerClass: 'p-2',
                                        modalClass: this.$store.getters.getTheme,
                                        hideHeaderClose: true,
                                        centered: true
                                    })
            } else {
                return !this.$bvModal.msgBoxOk(redirecionamento.redirecionamento.mensagem,
                    {
                        id: 'msgbox-redirecionamento',
                        'modal-class': "dark",                        
                        'title': redirecionamento.redirecionamento.tituloTela,
                        headerBgVariant: 'primary',
                        okVariant: 'secondary',
                        okTitle: "Voltar",
                        footerClass: 'p-2',
                        modalClass: this.$store.getters.getTheme,
                        hideHeaderClose: true,
                        centered: true
                    })                

            }
        }
    }
}